import script from "./MarketData.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketData.vue?vue&type=script&setup=true&lang=js"

import "./MarketData.vue?vue&type=style&index=0&id=a7ac78d4&lang=scss&scoped=true"

import exportComponent from "/builds/p3839/client-suite/proxima_blue2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7ac78d4"]])

export default __exports__